// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"573":"bb4f7a5d","574":"c2c776e4","848":"2b29b096"}[chunkId] + ".chunk.js";
};